module.exports = __webpack_public_path__ + "static/media/bluelogo.ffd82817.svg";